/**
 * The studio's non-photographic surfaces.
 *
 * **Why this file exists (5 Nov 2026).** Two things on the front page are
 * neither a photograph nor type on the open page: the Settings tile and the
 * Week Ahead panel. Both were drawn separately, both got the colour wrong in
 * the same way — a mid-grey panel and then a paper one, each reading as
 * something laid on top of the design rather than part of it — and both were
 * corrected by Tom in the same week with the same note: it looks stuck on.
 *
 * The fix in both cases was to take the surface down to the depth of the
 * photographs' own shadows and let a charcoal edge do the work of a border.
 * Holding the two values here rather than in each component is what stops
 * that being rediscovered a third time, and makes the two panels visibly one
 * family instead of two near-misses.
 *
 * **The rule, which is what actually matters:** a panel sitting ON the studio
 * page uses this ground. Paper (#F4F1EA) is for pages a CLIENT reads — the
 * review pages, the wrap-up reports, a call sheet — and for nothing on the
 * staff side. If a staff panel needs to be lighter than its surroundings,
 * that is a hierarchy problem to solve with type, not a change to this file.
 *
 * Judge any change to these against the DARKEST part of the tiles beside
 * them, never against the gradient behind them.
 */

/** The ground of a panel on the studio page. */
export const PANEL_GROUND = '#121112'

/** Its edge — the brand charcoal, so the square has a boundary without a rule. */
export const PANEL_EDGE = '#262324'
